module.exports = __webpack_public_path__ + "static/img/t28.2b8f32fa.png";